import { css } from '@genesislcap/web-core';
import { cancelButtonBg, cancelButtonBgHover, closeIconStyles } from '../../../../styles';

export const dealSubmitPreviewStyles = css`
  .submit-result {
    box-sizing: border-box;
    min-height: 190px;
    position: relative;
  }

  deal-submit-preview-grid {
    display: block;
    margin-bottom: 20px;
    padding: 0 5px;
  }

  .submit-preview {
    min-width: 1200px;
    width: 1650px;
  }

  .submit-preview-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 24px;
    width: 100%;
    padding-top: 8px;
    border-top: 1px solid var(--neutral-stroke-divider-rest);
  }

  .submit-preview-actions--cancel-only,
  .submit-preview-actions--end {
    justify-content: flex-end;
  }

  .submit-preview-summary {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 16px 24px;
    flex: 1;
    min-width: 0;
  }

  .summary-row {
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }

  .summary-label {
    font-size: 14px;
    font-weight: 500;
    color: var(--neutral-foreground-rest);
    white-space: nowrap;
  }

  .summary-amount {
    font-size: 14px;
    font-weight: 600;
    color: var(--neutral-foreground-rest);
    white-space: nowrap;
  }

  .submit-preview-buttons {
    display: flex;
    flex-shrink: 0;
    gap: 12px;
  }

  .submit-preview-close-button {
    margin-right: 8px;
  }

  .submit-result-close-button {
    float: right;
  }

  .cancel-orders-button::part(control) {
    background: color-mix(in srgb, var(--error-color) 70%, transparent);
    border-color: var(--error-color);
  }

  .cancel-orders-button::part(control):hover {
    background: var(--error-color);
    border-color: var(--error-color);
  }

  .submit-in-progress {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;

    rapid-icon {
      display: block;
      font-size: 40px;
      margin: 20px;
    }

    .submit-success-icon {
      color: #7acc79;
    }

    .submit-failure-icon {
      color: #f9644d;
    }

    .submit-warning-icon {
      color: #e6a800;
    }
  }

  .deal-submit-preview-grid-grid {
    overflow: hidden;
    width: 100%;
    min-width: 100%;
  }

  .submit-modal::part(dialog) {
    max-width: 100%;
    min-width: unset;
    background: var(--neutral-layer-4);
    overflow: hidden;
  }

  .submit-modal::part(content) {
    width: auto;
    max-height: 80vh;
    overflow-y: auto;
  }

  .reconfirm-modal-content {
    max-width: 440px;
    padding: 0 8px;
  }

  .reconfirm-modal-content p {
    margin: 0 0 12px;
    color: var(--neutral-foreground-rest);
    font-size: 14px;
    line-height: 1.4;
  }

  .reconfirm-modal-content p:last-of-type {
    margin-bottom: 20px;
  }

  .reconfirm-modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 20px;
  }

  .reconfirm-cancel-button::part(control) {
    background-color: ${cancelButtonBg};
    border: 1px solid ${cancelButtonBg};
    color: #fff;
  }

  .reconfirm-cancel-button::part(control):hover {
    background-color: ${cancelButtonBgHover};
  }

  ${closeIconStyles}
`;
